import React from "react";

export default function EndDateChoice({
  id,
  legend = "Ends",
  required = false,
  openEnded,
  value = "",
  min,
  max,
  disabled = false,
  openEndedLabel = "No end date",
  openEndedHelp,
  error,
  onBlur,
  onChange,
}) {
  const noEndId = `${id}-no-end`;
  const onDateId = `${id}-on-date`;
  const helpId = `${id}-help`;
  const errorId = `${id}-error`;
  return (
    <fieldset className="schedule-end-choice" disabled={disabled}>
      <legend>
        {legend}
        {required ? <span style={{ color: "red" }}> *</span> : null}
      </legend>
      <div className="schedule-end-options">
        <div className="schedule-end-row">
          <label htmlFor={noEndId} className="schedule-end-option">
            <input
              id={noEndId}
              type="radio"
              name={`${id}-mode`}
              checked={openEnded}
              aria-describedby={openEndedHelp ? helpId : undefined}
              onChange={() => onChange({ openEnded: true, value })}
            />
            <span>{openEndedLabel}</span>
          </label>
          {openEndedHelp ? <span className="schedule-end-help" id={helpId}>{openEndedHelp}</span> : null}
        </div>
        <div className="schedule-end-row">
          <label htmlFor={onDateId} className="schedule-end-option">
            <input
              id={onDateId}
              type="radio"
              name={`${id}-mode`}
              checked={!openEnded}
              onChange={() => onChange({ openEnded: false, value })}
            />
            <span>On</span>
          </label>
          <input
            id={`${id}-date`}
            className="form-control schedule-end-date"
            type="date"
            aria-label="End date"
            aria-invalid={!openEnded && !!error}
            aria-describedby={!openEnded && error ? errorId : undefined}
            disabled={disabled || openEnded}
            required={!openEnded}
            min={min || undefined}
            max={max || undefined}
            value={value}
            onBlur={onBlur}
            onChange={(event) => onChange({ openEnded: false, value: event.target.value })}
          />
        </div>
      </div>
      {!openEnded && error ? <div className="error-text" id={errorId} role="alert">{error}</div> : null}
    </fieldset>
  );
}
